export default "__VITE_ASSET__DhC3W6wQ__"